module.exports = __webpack_public_path__ + "img/foundations.efee34a.jpg";